import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function LeadSection() {
  return <section id="lead" className="py-14 md:py-32 bg-charcoal relative" data-id="element-208" data-mp="1cvod9fsgfhm9">
      <div className="max-w-3xl mx-auto px-6" data-id="element-209" data-mp="1ctv2boat6b8g">
        <FadeIn data-id="element-210" data-mp="1hmej0u4slmhh">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-sand mb-8 md:mb-12 text-center" data-id="element-211" data-mp="1hnzcshja91ea">
            Hay momentos en que todo debería estar bien.
          </h2>
        </FadeIn>

        <div className="space-y-5 md:space-y-8 text-base md:text-xl text-offwhite-dim leading-relaxed" data-id="element-212" data-mp="ozak96wam4e5">
          <FadeIn delay={0.1} data-id="element-213" data-mp="txv9ycdx55oc">
            <p data-id="element-214" data-mp="tz6fagn0ilhk">
              Tenés lo que necesitás. Rindés. Cumplís. Desde afuera, tu vida
              está bien.
            </p>
            <p className="mt-4 font-medium text-offwhite" data-id="element-215" data-mp="13vsxsyrv90gf">Pero algo no cierra.</p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-216" data-mp="2abv75fldqh7w">
            <p className="text-2xl md:text-3xl font-heading font-bold text-amber" data-id="element-217" data-mp="2aak5pmfepljy">
              No es que estés mal. Es que no estás completo.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-218" data-mp="3mfi5n96mfzyx">
            <p data-id="element-219" data-mp="3megvr81cdjis">
              Te levantás sin energía aunque dormiste. Empezás el día con
              intención y a las 2 horas ya perdiste el hilo. Hacés cosas, pero
              no sentís que avanzan. Estás presente en todo… y en nada al mismo
              tiempo.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-220" data-mp="38f7cu0lr4bb4">
            <p data-id="element-221" data-mp="33g4ainx5oj6u">
              No es pereza. No es falta de voluntad. No es que "no tenés ganas".
              Tu cuerpo manda una señal, tu mente manda otra, y lo que querés de
              verdad lleva tiempo sin que lo escuches.
            </p>
            <p className="mt-4" data-id="element-222" data-mp="2tr48evncx7of">
              Cuando esas cosas no van juntas, nada fluye en armonía. Las
              relaciones se tensan. El trabajo se siente pesado. Los hábitos no
              duran. La paz se escapa justo cuando creés que la tenés.
            </p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-223" data-mp="2fs4jrnzugss9">
            <div className="border-l-4 border-sand pl-6 py-2" data-id="element-224" data-mp="2fswekwlmamhh">
              <p className="text-xl md:text-2xl font-heading font-bold text-offwhite" data-id="element-225" data-mp="262eh4cgn50nr">
                La incoherencia no es un concepto. La incoherencia se siente.
              </p>
            </div>
            <p className="mt-6" data-id="element-226" data-mp="1w6bd1128ary6">
              Y lo más confuso es esto: no podés señalar exactamente qué está
              mal. Porque no hay una sola cosa.{' '}
              <span className="text-sand font-medium" data-id="element-227" data-mp="2ot5l0yhuzyur">
                Es todo un poco desalineado.
              </span>
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}